import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import React from 'react'

import { HorizontalLine } from '../../components/shapes/Line'
import { SmallText, Text } from '../../components/presentation/Text'
import { useIsPermalinkPage } from '../../utils/session/permalinkToken'
import { useOpenServiceOrderModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid, { FlexCol } from '../../components/structure/FlexGrid'
import IconLink from '../../components/actions/IconLink'
import Separator from '../../components/helpers/Separator'
import StatusTag from '../serviceOrders/StatusTag'
import Panel from '../../packages/kiti/components/structure/Panel'

const ActionPlanListItem = ({ item, onRemove, index }) => {
  const openModal = useOpenServiceOrderModal()
  const canSeeMoreDetails = !useIsPermalinkPage() && !!item.id
  const checklistName = capitalizeIfLower(item.service?.name || item.checklist?.name)
  const responsibleName = capitalizeAllIfLower(item.user?.name || item.group?.name)
  const status = item.serviceStatus || item.status

  return (
    <Panel lineBorder noMargin paddingV={0.5} paddingH={1}>
      <FlexGrid gutter={0.2} justify="flex-start">
        <FlexCol flex={1}>
          <Text>{checklistName}</Text>
          <Text size="xsmall">Responsável: {responsibleName}</Text>
        </FlexCol>
        {status && (
          <FlexCol flex={1}>
            <StatusTag item={status} />
          </FlexCol>
        )}
        {canSeeMoreDetails && (
          <IconLink name="BsSearch" color={COLORS.dark3} size="0.875rem" onClick={() => openModal(item)} />
        )}
        {!item.id && onRemove && (
          <IconLink name="BsTrash" color={COLORS.red} size="0.875rem" onClick={() => onRemove(item, index)} />
        )}
      </FlexGrid>
    </Panel>
  )
}

const ActionPlanList = ({ items, hideLabel, onClickItem, ...props }) => {
  return (
    <div>
      {!hideLabel && (
        <>
          <Separator weight={4} />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <SmallText size="xsmall">Planos de Ação</SmallText>
          <Separator weight={2} />
        </>
      )}

      <FlexGrid direction="column" gutter={0.2} align="stretch">
        {items.map((item, index) => (
          <ActionPlanListItem key={item.id} item={item} {...props} index={index} />
        ))}
      </FlexGrid>
    </div>
  )
}

export default ActionPlanList
